<template>
    <div>
        <div class="md-layout optimised-stop-address-block">
            <div class="md-layout-item">
                <span>{{ content.address }}</span>
            </div>
        </div>
        <div class="md-layout md-alignment-center-space-between">
            <div class="md-layout-item md-size-60 stop-team-member-block">
                <span class="team-member-image">
                    <img v-if="content.photoUrl"
                         class="profile-image"
                         :src="content.photoUrl"
                         @error="$_setDefaultBrokenImage"
                         alt />
                    <img v-else class="member-image" :src="$root.defaultPhotoUrl" alt />
                </span>
                <span class="left-margin">{{ content.teamMemberName }}</span>
            </div>
        </div>
        <table class="md-table">
            <tbody>
                <tr>
                    <th class="md-table-head"></th>
                    <th class="md-table-head">Stop Ref</th>
                    <th class="md-table-head stop-multi-address">Name</th>
                    <th class="md-table-head">Phone</th>
                    <template v-if="hasCapacitySettings('quantity', 'volume', 'weight')">
                        <th v-if="hasCapacitySettings('quantity')" class="md-table-head">
                            <md-icon>
                                <img class="capacity-images" src="/img/icons/capacity-items-gray.png" />
                            </md-icon>
                        </th>
                        <th v-if="hasCapacitySettings('volume')" class="md-table-head">
                            <md-icon>
                                <img class="capacity-images" src="/img/icons/capacity-volume-gray.png" />
                            </md-icon>
                        </th>
                        <th v-if="hasCapacitySettings('weight')" class="md-table-head">
                            <md-icon>
                                <img class="capacity-images" src="/img/icons/capacity-weight-gray.png" />
                            </md-icon>
                        </th>
                    </template>
                    <template v-if="hasSkillsSettings()">
                        <th class="md-table-head">
                            <span>Skills</span>
                        </th>
                    </template>
                    <template v-if="hasServiceSettings()">
                        <th class="md-table-head">
                            <span>Services</span>
                        </th>
                    </template>
                </tr>
                <tr v-for="(stop, index) in content.stopList" :key="index">
                    <td class="md-table-cell md-stop">{{ stop.stopIndex }}</td>
                    <td class="md-table-cell md-stop stop-ref-block" @click="showDetailsPage(stop)"><span>{{ stop.stopRef }}</span></td>
                    <td class="md-table-cell md-stop stop-multi-address">{{ stop.contact.name || '-' }}</td>
                    <td class="md-table-cell md-stop">{{ stop.contact.phone || '-' }}</td>
                    <template v-if="hasCapacitySettings('quantity', 'volume', 'weight')">
                        <td v-if="hasCapacitySettings('quantity')" class="md-table-cell md-stop">
                            {{ getCapacityInfo(stop, 'quantity', 'items') }}
                        </td>
                        <td v-if="hasCapacitySettings('volume')" class="md-table-cell md-stop">
                            {{ getCapacityInfo(stop, 'volume', 'm3') }}
                        </td>
                        <td v-if="hasCapacitySettings('weight')" class="md-table-cell md-stop">
                            {{ getCapacityInfo(stop, 'weight', 'kg') }}
                        </td>
                    </template>
                    <template v-if="hasSkillsSettings()">
                        <td class="md-table-cell md-stop">
                            <span>{{ getSkillsInfo(stop) }}</span>
                        </td>
                    </template>
                    <template v-if="hasServiceSettings()">
                        <td class="md-table-cell md-stop">
                            <span>{{ getServiceInfo(stop) }}</span>
                        </td>
                    </template>
                    <td class="md-table-cell md-stop">
                        <div class="md-layout-item md-size-40 stop-button-block stop-multi-buttonclock">
                            <delete-stop-button class="info--buttons md-primary md-button md-just-icon md-round"
                                                :stop-id="stop.stopId"
                                                :vehicle-id="stop.vehicleId"
                                                :allocate-stops="content.allocateStops"
                                                :stop-ref="stop.stopRef"
                                                :address="stop.address"
                                                @stopDeleted="handleDeleteStop" />
                            <reassign-stop-button :team-members="content.teamMembers"
                                                  :allocate-stops="content.allocateStops"
                                                  :stop-id="stop.stopId"
                                                  :vehicle-id="stop.vehicleId"
                                                  @reassignedStop="handleReassignedStop" />
                            <md-button v-if="content.trackingLinkUrl"
                                       title="tracking link"
                                       class="info--buttons md-primary md-button md-just-icon md-round"
                                       :md-ripple="false"
                                       @click="showTrackingLink">
                                <md-icon>directions_car</md-icon>
                            </md-button>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import { GeneralMixin } from '@/mixins';
import { DeleteStopButton, ReassignStopButton } from '@/pages/BatchStop/buttons';

export default {
    name: 'InfoWindowMultiStopContent',
    components: {
        DeleteStopButton,
        ReassignStopButton
    },
    mixins: [GeneralMixin],
    props: {
        content: {
            type: Object,
            default: () => {}
        },
        showDetailsPage: {
            type: Function,
            default: () => {}
        },
        getCapacityInfo: {
            type: Function,
            default: () => {}
        },
        hasCapacitySettings: {
            type: Function,
            default: () => {}
        },
        getSkillsInfo: {
            type: Function,
            default: () => {}
        },
        hasSkillsSettings: {
            type: Function,
            default: () => {}
        },
        getServiceInfo: {
            type: Function,
            default: () => {}
        },
        hasServiceSettings: {
            type: Function,
            default: () => {}
        }
    },
    methods: {
        showTrackingLink(stop) {
            window.open(`${stop.trackingLinkUrl}?isAdmin=true&showPOD=true`, '_blank');
        },
        handleReassignedStop(record, stopId, vehicleId) {
            const reassignedTripStop = {
                records: [record],
                stops: [stopId],
                vehicleId
            };
            this.$emit('handleReassignedStop', reassignedTripStop);
        },
        handleDeleteStop(stopId, vehicleId) {
            const deleteTripStops = {
                stops: [stopId],
                vehicleId
            };
            this.$emit('handleDeleteStop', deleteTripStops);
        }
    }
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/md/_colors.scss';
.md-content {
    font-weight: bold;
}

.optimised-stop-ref-block {
    span {
        color: #2b93ff;
        cursor: pointer;
    }
}
    .optimised-stop-address-block {
        padding-bottom: 20px;
        span {
            font-weight: bold;
        }
    }

#optimised-stop-ref-visibility-icon {
    color: #2b93ff !important;
}
.left-margin {
    margin-left: 4px !important;
}
.md-stop {
    padding-top: 0px !important;
}
.team-member-image {
    width: 40px;
    margin-top: -5px;
    img {
        width: 24px;
        border-radius: 50%;
    }
}

.stop-ref-block {
    span {
        color: #2b93ff;
        cursor: pointer;
    }
    button {
        height: 16px;
        margin: 0 !important;
        top: -1px;
    }
}

.stop-address-block {
    span {
        font-weight: 700;
    }
}

.stop-status-block {
    span {
        font-weight: 400;
    }
}

.custom-button-container {
    margin-top: -9px;
    button,
    ::v-deep button {
        margin: 0px 0px;
        min-width: 29px !important;
        width: 29px !important;
        height: 29px !important;
    }
    button:last-child {
        margin-right: 0;
    }
}
.stop-button-block {
    padding-left: 0 !important;
    button {
        margin: 0 0 0 2px !important;
        width: 29px !important;
        height: 29px !important;
        min-width: 29px !important;
        margin-left: 2px;
    }

    .custom-button-container {
        margin-top: -14px;
        margin-left: 2px;
        button {
            top: -14px;
        }
    }

    > * {
        float: right;
    }
}
.stop-multi-buttonclock {
    max-width: 100% !important;
}
.stop-team-member-block {
    padding-right: 0 !important;
    img {
        margin: 0 !important;
        width: 29px !important;
        height: 29px !important;
    }
}
.stop-multi-address {
    min-width: 120px !important;
}
.stop-container {
    .md-layout {
        margin-top: 5px;
        margin-bottom: 5px;
    }
}

#stop-ref-visibility-icon {
    color: #2b93ff !important;
}
</style>
